import script from "./HtmlMeta.vue?vue&type=script&lang=js"
export * from "./HtmlMeta.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__